import { render, staticRenderFns } from "./HeaderStores.vue?vue&type=template&id=188f4d47&scoped=true"
import script from "./HeaderStores.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderStores.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderStores.vue?vue&type=style&index=0&id=188f4d47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f4d47",
  null
  
)

export default component.exports